// SERVICES
import Http from '../../services/Http'

// public sector
export default class Repo {
  constructor (resource) {
    this.http = new Http()
    this.resource = resource
  }

  store (data) {
    return this.http.post(this.resource, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  update (id, data) {
    return this.http.put(this.resource + '/' + id, data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  get (id, includes) {
    return this.http.get(this.resource + '/' + id, includes).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  all (q = undefined, includes) {
    let url = this.resource

    if (q !== undefined) {
      url = url + '?q=' + q
    }
    return this.http.get(url, includes).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  delete (id) {
    return this.http.delete(this.resource + '/' + id).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }

  search (data) {
    return this.http.post(this.resource + '/search', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
  paginate (data, include) {
    if(include){
      data.include = include;
    }
    return this.http.get(this.resource + '/paginate', data).then((response) => {
      return Promise.resolve(response)
    }).catch((response) => {
      return Promise.reject(response)
    })
  }
}
